const IMG_BASE_URL = "https://d1rgemtytdlz2g.cloudfront.net";
const IMG_BASE_URL_NEXTJS = "https://d3ib4ot6oar1ep.cloudfront.net";
const SOURCE_UTM = "source_custom_utm";
const PRODUCTION_ENV = "production";
const IP_DATA_KEY = "f2f334b89f92f60f47e0198355537a6eeee9012ea4106a9729bbb58f";
const SESSION = {
    shouldPreventLayoutSwitch: "swl"
};
const COOKIES = {
    token: "vt",
    isVerified: "vv",
    isEmailVerified: "ev",
    isRecoveryEmailVerified: "rev",
    customerCompanyId: "ccid",
    customerPhone: "cpn",
    customerName: "cname",
    customerCompanyLocation: "ccloc",
    csDashboardUserRoles: "csdsbUserRoles",
    csDashboardPermission: "csdsbPerm",
    phoneNum: "phoneNum",
    companyId: "ci",
    companyName: "name",
    companyLocation: "cloc",
    kycPopupInitialLoad: "kip",
    historyLocation: "hl",
    companyLogo: "cLogo",
    userId: "ui",
    serviceType: "st",
    recentTransporterCitySearches: "rtcs",
    currentLoc: "loc",
    callbackRequestedTimestamp: "cr",
    aadharVerificationAttempts: "av",
    blockAadharVerification: "ba",
    blockGstVerification: "bg",
    bulkRequestIdArray: "bri",
    customerServiceType: "cst",
    fromFlutterApp: "fromFlutterApp",
    citySearchCount: "ctCtySch",
    transporterSearchCount: "ctTspSch",
    abTest: "abt",
    exitIntPopup: "exp",
    wrongTurnPop: "wtp",
    referralCode: "rfc",
    sessionId: "sid",
    vahakAutomation: "va",
    thirdPartyCompanyName: "tpc",
    newUser: "newUser"
};
const LOC_STORAGE = {
    callbackRequestedTimestamp: "cr",
    requestedTicketTimestamp: "req-tkt",
    clickToCallMpcMode: "ctc-mpc"
};
const DefaultCookieOptions = {
    path: "/",
    secure: process.env.REACT_APP_ENV === "production" || process.env.NEXT_PUBLIC_REACT_APP_ENV === "production",
    sameSite: "strict",
    maxAge: 24 * 60 * 60 * 30
};
const CUSTOM_EVENTS = {
    LOGGEDIN: "registered user or logged in user"
};
const PopularDest = [
    { state_id: 1, state: "Maharashtra" },
    { state_id: 4, state: "Gujarat" },
    { state_id: 2, state: "Delhi" },
    { state_id: 3, state: "Karnataka" }
];
var BadgeTypes;
(function (BadgeTypes) {
    BadgeTypes[BadgeTypes["DEFAULT"] = 0] = "DEFAULT";
    BadgeTypes[BadgeTypes["WARNING"] = 1] = "WARNING";
    BadgeTypes[BadgeTypes["ACTIVE"] = 2] = "ACTIVE";
    BadgeTypes[BadgeTypes["PROGRESS"] = 3] = "PROGRESS";
    BadgeTypes[BadgeTypes["COMPLETED"] = 4] = "COMPLETED";
    BadgeTypes[BadgeTypes["PUBLISHED"] = 5] = "PUBLISHED";
})(BadgeTypes || (BadgeTypes = {}));
var ComponentState;
(function (ComponentState) {
    ComponentState[ComponentState["NORMAL"] = 0] = "NORMAL";
    ComponentState[ComponentState["LOADING"] = 1] = "LOADING";
})(ComponentState || (ComponentState = {}));
const DEFAULT_COMPANY_LOGO = "default.png";
const HEADER_ITEM_ATTRIBUTE = "header-item-attribute";
var HeaderItemsConstants;
(function (HeaderItemsConstants) {
    HeaderItemsConstants["SERVICE_MENU"] = "service-menu";
    HeaderItemsConstants["MARKETPLACE"] = "marketplace";
    HeaderItemsConstants["TRANSPORT_DIRECTORY"] = "transport-directory";
    HeaderItemsConstants["RESOURCES_MENU"] = "resources";
    HeaderItemsConstants["COMPANY_MENU"] = "company";
    HeaderItemsConstants["LOGIN"] = "login";
    HeaderItemsConstants["MEMBERSHIP"] = "membership";
})(HeaderItemsConstants || (HeaderItemsConstants = {}));
const FOOTER_ITEM_ATTRIBUTE = "footer-item-attribute";
var FooterItemsConstant;
(function (FooterItemsConstant) {
    FooterItemsConstant["ABOUT_US"] = "about-us";
    FooterItemsConstant["CONTACT_US"] = "contact-us";
    FooterItemsConstant["CAREERS"] = "careers";
    FooterItemsConstant["NEWSLETTER"] = "newsletter";
    FooterItemsConstant["CONNECT_WITH_US"] = "connect-with-us";
    FooterItemsConstant["DOWNLOAD_OUR_APP"] = "download-our-app";
    FooterItemsConstant["FAQ"] = "faq";
    FooterItemsConstant["TERMS_AND_CONDITION"] = "terms-and-condition";
    FooterItemsConstant["PAYMENT_GUIDELINES"] = "payment-guidelines";
    FooterItemsConstant["CASHBACK_TERMS_AND_CONDITIONS"] = "cashback-terms-and-conditions";
    FooterItemsConstant["MEDIBUDDY_TERMS_AND_CONDITIONS"] = "medibuddy-terms-and-conditions";
    FooterItemsConstant["TAP_N_GO_TERMS_AND_CONDITIONS"] = "tap-n-go-terms-and-conditions";
    FooterItemsConstant["BUSINESS_LOANS_TERMS_AND_CONDITIONS"] = "business-loans-terms-and-conditions";
    FooterItemsConstant["CI_TERMS_AND_CONDITIONS"] = "ci-terms-and-conditions";
    FooterItemsConstant["GPS_TERMS_AND_CONDITIONS"] = "gps-terms-and-conditions";
    FooterItemsConstant["PRIVACY_POLICY"] = "privacy-policy";
    FooterItemsConstant["NEWSLETTER_SUBSCRIBED"] = "newsletter-subscribed";
})(FooterItemsConstant || (FooterItemsConstant = {}));
const FB_PIXEL_ID = "466348821937832";
const FB_CAPI_TOKEN = "EAAFGkspC5FIBR8AuEtpezYbxjDHL1YfF6KfjoRlchYKVC2cr5min1ZAZC0Aj6C4AswZCYNRSmfQdbLO92lZBkUfSc4lOqcGbA5Hqo9UnMPznWHpePl5S3P55q0kvtmXCPiFkuKhW7zv2gDwoFLdIQZBdGqPjxt7V7h3o03u8utWdwjMZBcJIj5xU29JBMW4wZDZD";
const MEMBERSHIP_FEATURE = "https://www.youtube.com/embed/Cc_T6ym0zEQ?si=ETYCxekk991-Zd-c";
const APP_LINK = "https://app.vahak.in/46EB9yJRwkb";
const BID_HISTORY_STATUS_MAP = {
    0: "Waiting",
    1: "Rejected",
    2: "Approved",
    3: "Completed",
    4: "In Transit"
};
const CASHFREE_PAYMENT_SUCCESS_STATUS = ["PAID", "TO_SETTLE", "CFLINK_SUCCESS"];
const WHATSAPP_CHAT = "https://chat.whatsapp.com/HNbwsUwyircDXIBsqk5jus";
const VAHAK_EMAIL = "cs@vahak.in";
const VAHAK_EMAIL_INFO = "info@vahak.in";
const VAHAK_PHONE = "+918035738071";
const REF_VIEWPORT_HEIGHT = 812;
const REF_VIEWPORT_WIDTH = 375;
var FONT_WEIGHTS;
(function (FONT_WEIGHTS) {
    FONT_WEIGHTS[FONT_WEIGHTS["extraBold"] = 1000] = "extraBold";
    FONT_WEIGHTS[FONT_WEIGHTS["bold"] = 850] = "bold";
    FONT_WEIGHTS[FONT_WEIGHTS["semiBold"] = 600] = "semiBold";
    FONT_WEIGHTS[FONT_WEIGHTS["medium"] = 550] = "medium";
    FONT_WEIGHTS[FONT_WEIGHTS["normal"] = 400] = "normal";
})(FONT_WEIGHTS || (FONT_WEIGHTS = {}));
const CACHE_NAME = "v-cache";
const EXPIRED_LORRY_STATUS = [0, 4];
const USER_PROFILE_MODAL_TITLE = {
    "company-details": "ABOUT COMPANY",
    "my-routes": "MY ROUTES",
    "my-lorries": "MY LORRIES",
    "office-address": "OFFICE ADDRESSES",
    "document-verification": "Document Verification",
    "company-bio": "Company Bio",
    reviews: "My Reviews",
    faqs: "FAQS",
    aadharVerification: "Aadhaar Verification",
    gstVerification: "Business Document Verification"
};
const CITIES_WITH_CITY_PAGES = [
    "mumbai",
    "delhi",
    "bangalore",
    "kolkata",
    "chennai",
    "hyderabad",
    "ahmedabad",
    "jaipur",
    "pune"
];

export { APP_LINK, BID_HISTORY_STATUS_MAP, BadgeTypes, CACHE_NAME, CASHFREE_PAYMENT_SUCCESS_STATUS, CITIES_WITH_CITY_PAGES, COOKIES, CUSTOM_EVENTS, ComponentState, DEFAULT_COMPANY_LOGO, DefaultCookieOptions, EXPIRED_LORRY_STATUS, FB_CAPI_TOKEN, FB_PIXEL_ID, FONT_WEIGHTS, FOOTER_ITEM_ATTRIBUTE, FooterItemsConstant, HEADER_ITEM_ATTRIBUTE, HeaderItemsConstants, IMG_BASE_URL, IMG_BASE_URL_NEXTJS, IP_DATA_KEY, LOC_STORAGE, MEMBERSHIP_FEATURE, PRODUCTION_ENV, PopularDest, REF_VIEWPORT_HEIGHT, REF_VIEWPORT_WIDTH, SESSION, SOURCE_UTM, USER_PROFILE_MODAL_TITLE, VAHAK_EMAIL, VAHAK_EMAIL_INFO, VAHAK_PHONE, WHATSAPP_CHAT };
//# sourceMappingURL=misc.js.map
